var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.859,
    height: 61.165,
    viewBox: "0 0 57.859 61.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5407",
    "data-name": "Group 5407",
    transform: "translate(-682 -813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(668.162 813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341",
    transform: "translate(19.634 11.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5340",
    "data-name": "Group 5340",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M103.682,98.512l-3.9,44.437H71.193l-3.9-44.437-4.94.433,3.97,45.243a4.175,4.175,0,0,0,4.12,3.72h30.087a4.183,4.183,0,0,0,4.124-3.75l3.967-45.213Z",
    transform: "translate(-62.354 -98.512)",
    fill: "#90205d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5343",
    "data-name": "Group 5343",
    transform: "translate(29.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5342",
    "data-name": "Group 5342",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M167.614,0H149.43A4.137,4.137,0,0,0,145.3,4.133v7.852h4.959V4.959h16.531v7.026h4.959V4.133A4.137,4.137,0,0,0,167.614,0Z",
    transform: "translate(-145.297)",
    fill: "#90205d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5345",
    "data-name": "Group 5345",
    transform: "translate(13.838 9.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5344",
    "data-name": "Group 5344",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M69.217,79.568h-52.9a2.48,2.48,0,1,0,0,4.959h52.9a2.48,2.48,0,1,0,0-4.959Z",
    transform: "translate(-13.838 -79.568)",
    fill: "#90205d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.d5ea4284.svg";
export { ForwardRef as ReactComponent };